import * as swcHelpers from '@swc/helpers';
import React__default, { useContext } from 'react';
import { debounce } from 'throttle-debounce';
import { Context } from '@grandvisionhq/carts-v2';
import { Form } from '@grandvisionhq/forms';
import { ProfileSelectors } from '@grandvisionhq/my-account';
import { createSlotsContext } from '@grandvisionhq/slots';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { updateShippingDetails } from '../../StepShipping/actions.js';
import { getShippingDetails } from '../../StepShipping/selectors.js';

const [FormSlotsProvider, useBaseFormSlot] = createSlotsContext({
    displayName: 'FormSlotsContext'
});
const useFormSlot = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const dispatch = useDispatch();
    const { Slots  } = useBaseFormSlot();
    const shippingData = useSelector(getShippingDetails);
    const cartContext = useContext(Context.CartContext);
    const profileDateOfBirthValue = (ref = useSelector(ProfileSelectors.getFormData)) === null || ref === void 0 ? void 0 : (ref1 = ref.personalDetails) === null || ref1 === void 0 ? void 0 : ref1.dateOfBirth;
    const cartContainsContactLenses = cartContext === null || cartContext === void 0 ? void 0 : (ref2 = cartContext.cart) === null || ref2 === void 0 ? void 0 : ref2.contains.contactLenses;
    const cartContainsSolutions = cartContext === null || cartContext === void 0 ? void 0 : (ref3 = cartContext.cart) === null || ref3 === void 0 ? void 0 : ref3.contains.solutions;
    const cartContainsPrescriptionGlasses = cartContext === null || cartContext === void 0 ? void 0 : (ref4 = cartContext.cart) === null || ref4 === void 0 ? void 0 : ref4.contains.prescriptionGlasses;
    const cartContainsSunglasses = cartContext === null || cartContext === void 0 ? void 0 : (ref5 = cartContext.cart) === null || ref5 === void 0 ? void 0 : ref5.contains.sunglasses;
    const cartContainsSubscription = cartContext === null || cartContext === void 0 ? void 0 : (ref6 = cartContext.cart) === null || ref6 === void 0 ? void 0 : ref6.contains.subscription;
    const cartContainsContactLensesSubscription = cartContext === null || cartContext === void 0 ? void 0 : (ref7 = cartContext.cart) === null || ref7 === void 0 ? void 0 : ref7.contains.contactLensesSubscription;
    const handleChange = React__default.useCallback((formData)=>{
        (props === null || props === void 0 ? void 0 : props.onChange) ? props === null || props === void 0 ? void 0 : props.onChange(formData) : dispatch(updateShippingDetails({
            form: formData
        }));
    }, [
        dispatch,
        props
    ]);
    const debouncedHandleChange = React__default.useMemo(()=>{
        return debounce(200, handleChange);
    }, [
        handleChange
    ]);
    React__default.useEffect(()=>{
        return ()=>debouncedHandleChange.cancel()
        ;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   *  Iterate over all form components passed by opco
   *  Bind data to form component
   **/ const forms = Object.entries(Slots).reduce((formItem, [key, Slot])=>{
        let formData = shippingData && shippingData[key] ? shippingData[key].formData : {};
        /**
     *  Prefill express checkout DOB if the user has DOB data in "my account"
     **/ const expressCheckoutDOBKey = 'express-checkout-dob';
        const dobFormData = formData[expressCheckoutDOBKey];
        if (dobFormData && profileDateOfBirthValue) {
            formData = swcHelpers.objectSpread({}, formData, {
                [expressCheckoutDOBKey]: swcHelpers.objectSpread({}, dobFormData, {
                    value: dobFormData.value || profileDateOfBirthValue
                })
            });
        }
        formItem[key] = /*#__PURE__*/ React__default.createElement(Form, {
            name: key,
            "data-t": key,
            initialFormState: formData,
            onChange: debouncedHandleChange
        }, /*#__PURE__*/ React__default.createElement(Slot, {
            cartContainsContactLenses: cartContainsContactLenses,
            cartContainsSolutions: cartContainsSolutions,
            cartContainsSunglasses: cartContainsSunglasses,
            cartContainsSubscription: cartContainsSubscription,
            cartContainsPrescriptionGlasses: cartContainsPrescriptionGlasses,
            cartContainsContactLensesSubscription: cartContainsContactLensesSubscription
        }));
        return formItem;
    }, {});
    // Warning, these form objects are not memoized. When added to a dependency array, they will trigger rerender loops
    return forms;
};

export { FormSlotsProvider, useBaseFormSlot, useFormSlot };
//# sourceMappingURL=form-context.js.map
